import React, { Component } from 'react';
import {
  Col,
  Form,
  Card,
  Button,
  ListGroup,
  Row,
  Modal,
} from 'react-bootstrap';
import { FiSave } from 'react-icons/fi';
import { MdEdit, MdDelete } from 'react-icons/md';
import { toast } from 'react-toastify';
import { default as Selector } from 'react-select';
import { DropdownIndicator, customStyles } from '~/Styles/reactSelectStyles';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';

import * as api from '~/Services/Service';
import Header from '~/Components/Header/Header';
import Hint from '~/Components/Hint/Hint';
import { gerarAmbienteUrl } from '~/Pages/Vendas/helpers';

export class ConfiguracoesFluxoProspecto extends Component {
  state = {
    motivos: [],
    codigo_motivo_editando: 0,
    codigo_motivo_deletando: 0,
    descricao: '',
    tag: '',
    limite: null,
    tag_invalida: false,
    parametrosSegundoProponente: [],
    regraInicial: {
      codigo_familia: '',
      tempo_sem_atendimento: 30,
      utilizar_regra: false,
    },
  };

  validTagExpression = /^([a-z0-9]+_?)*$/;

  componentDidMount() {
    api
      .getParametrosGerais()
      .then(response => {
        this.setState({
          Limite: response.LimiteFluxoProspecto,
        });
      })
      .catch(error => {
        this.onError(error, 'Erro ao obter o parâmetro limite.');
      });

    api
      .getMotivosDescarte()
      .then(response => {
        this.setState({
          motivos: response,
        });
      })
      .catch(error => {
        this.onError(error, 'Erro ao obter os motivos de descarte.');
      });

    api
      .buscarParametrosSegundoProponente()
      .then(response => {
        this.setState({
          parametrosSegundoProponente: Array.isArray(response) ? response : [],
        });
      })
      .catch(error => {
        this.onError(error, 'Erro ao obter parâmetros do segundo proponente.');
      });
  }

  onError = (error, mensagem) => {
    console.error(error);
    toast.error(mensagem, {
      position: 'top-right',
    });
  };

  onSuccess = mensagem => {
    toast.success(mensagem, {
      position: 'top-right',
    });
  };

  salvarLimiteProspectosPorCorretor = async e => {
    e.preventDefault();
    this.setState({ isSubmitting: true });
    api
      .updateLimiteFluxoProspectos(this.state.limite)
      .then(() => {
        this.onSuccess('Limite atualizado com sucesso!');
        this.setState({ isSubmitting: false });
      })
      .catch(error => {
        this.onError(error, 'Erro ao atualizar o limite.');
        this.setState({ isSubmitting: false });
      });
  };

  adicionarMotivoDescarte = async e => {
    e.preventDefault();
    if (!this.state.tag.match(this.validTagExpression)) {
      this.setState({ tagInvalida: true });
      return;
    }
    this.setState({ tagInvalida: false });
    const motivo = {
      tag: this.state.tag,
      descricao: this.state.descricao,
      codigo: this.state.codigo_motivo_editando,
    };
    this.inserirOuAtualizarMotivo(motivo);
  };

  iniciarEditarMotivo = codigo => {
    const motivo = this.state.motivos.filter(m => m.codigo === codigo)[0];
    this.tagInput.focus();
    this.setState({
      tag: motivo.tag,
      descricao: motivo.descricao,
      codigo_motivo_editando: codigo,
    });
  };

  cancelarEditarMotivo = () => {
    this.setState({
      tag: '',
      descricao: '',
      codigo_motivo_editando: 0,
    });
  };

  iniciarEditarParametro = codigo_familia => {
    const p = (this.state.parametrosSegundoProponente || []).find(
      x => x.codigo_familia === codigo_familia
    );
    if (p) {
      this.setState({
        regraInicial: {
          codigo_familia: p.codigo_familia,
          tempo_sem_atendimento:
            typeof p.tempo_sem_atendimento_proponente === 'number'
              ? p.tempo_sem_atendimento_proponente
              : 30,
          utilizar_regra: !!p.usar_regra_proponente,
        },
      });
    }
  };

  inserirOuAtualizarMotivo = motivo => {
    this.setState({ isSubmitting: true });
    const editando = motivo.codigo === 0;
    api
      .inserirOrAtualizarMotivoDescarte(motivo)
      .then(response => {
        let motivos = this.state.motivos;
        if (motivo.codigo === 0) {
          motivo.codigo = response.codigo;
          motivos.push(motivo);
        } else
          motivos = motivos.map(m => (m.codigo === motivo.codigo ? motivo : m));
        this.setState({
          motivos: motivos,
          tag: '',
          descricao: '',
          codigo_motivo_editando: 0,
          isSubmitting: false,
        });
        const acao = editando ? 'adicionado' : 'editado';
        this.onSuccess(`Motivo ${acao} com sucesso!`);
      })
      .catch(error => {
        const acao = editando ? 'adicionar' : 'editar';
        this.onError(error, `Erro ao ${acao} o motivo.`);
        this.setState({
          tag: '',
          descricao: '',
          codigo_motivo_editando: 0,
          isSubmitting: false,
        });
      });
  };

  confirmarExcluirMotivo = codigo => {
    this.setState({
      confirmarExcluirMotivo: true,
      CodigoMotivoDeletando: codigo,
    });
  };

  cancelarExcluirMotivo = () => {
    this.setState({
      confirmarExcluirMotivo: false,
      CodigoMotivoDeletando: 0,
    });
  };

  excluirMotivo = () => {
    const codigo = this.state.codigo_motivo_deletando;
    this.setState({
      confirmarExcluirMotivo: false,
      CodigoMotivoDeletando: 0,
    });
    api
      .desativarMotivoDescarte(codigo)
      .then(() => {
        let motivos = this.state.motivos;
        motivos = motivos.filter(m => m.codigo !== codigo);
        this.setState({
          Motivos: motivos,
        });
        this.onSuccess('Motivo removido com sucesso!');
      })
      .catch(error => {
        this.onError(error, 'Erro ao remover o motivo.');
      });
  };

  handleChange = e => {
    let change = {};
    change[e.target.name] = e.target.value;
    this.setState(change);
  };

  render() {
    const {
      motivos,
      descricao,
      tag,
      limite,
      isSubmitting,
      confirmarExcluirMotivo,
      codigo_motivo_editando,
      tagInvalida,
    } = this.state;

    const motivoDesativando = this.state.motivos.filter(
      m => m.codigo === this.state.codigo_motivo_deletando
    )[0];
    const podeSalvarMotivo = descricao !== '' && tag !== '';
    return (
      <>
        <Header title="Configurações do Fluxo de Prospecto" />

        <Card className="m-4">
          <Card.Header>Parâmetro Geral</Card.Header>
          <Card.Body>
            <Col>
              <Form onSubmit={this.salvarLimiteProspectosPorCorretor}>
                <>
                  <Form.Group as={Row}>
                    <Form.Label column sm="2">
                      Limite
                      <Hint
                        title="Limite"
                        content={
                          <span>
                            Limite geral de prospectos por corretor, utilizado
                            quando não há limite definido por empreendimento{' '}
                            <a
                              target="blank"
                              href={
                                gerarAmbienteUrl(true) + '/PDV/Consultar.aspx'
                              }
                            >
                              nas configurações do PDV
                            </a>
                            .
                          </span>
                        }
                      />
                    </Form.Label>
                    <Col sm="4">
                      <Form.Control
                        type="number"
                        name="limite"
                        onChange={this.handleChange}
                        disabled={isSubmitting}
                        value={limite}
                        placeholder="Limite de prospectos por corretor"
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Col sm="12">
                      <Button
                        variant="outline-primary"
                        type="submit"
                        className="float-right"
                        disabled={isSubmitting}
                      >
                        <FiSave />
                        <span>&nbsp;Salvar</span>
                      </Button>
                    </Col>
                  </Form.Group>
                </>
              </Form>
            </Col>
          </Card.Body>
        </Card>

        <Card className="m-4">
          <Card.Header>Motivos de Descarte</Card.Header>
          <Card.Body>
            <Col>
              <Form onSubmit={this.adicionarMotivoDescarte}>
                <>
                  <Form.Group as={Row}>
                    <Form.Label column sm="2">
                      Tag
                      <Hint
                        title="Tag"
                        content="Tag inserida no contato do RdStation num evento de descarte do vínculo, se este for originado da Central de Atendimento. Deve conter apenas letras minúsculas, números e underscore. Exemplo: cliente_nao_responde."
                      />
                    </Form.Label>
                    <Col sm="6">
                      <Form.Control
                        type="text"
                        name="tag"
                        className={tagInvalida && 'is-invalid'}
                        ref={input => {
                          this.tagInput = input;
                        }}
                        onChange={this.handleChange}
                        disabled={isSubmitting}
                        value={tag}
                        placeholder="Tag do motivo (ex. cliente_nao_responde)"
                      />
                      <Form.Control.Feedback type="invalid">
                        Tag pode conter apenas letras minúsculas, números e
                        underscore. <br />
                        Exemplo: cliente_nao_responde.
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm="2">
                      Descrição
                    </Form.Label>
                    <Col sm="6">
                      <Form.Control
                        type="text"
                        name="descricao"
                        onChange={this.handleChange}
                        disabled={isSubmitting}
                        value={descricao}
                        placeholder="Descrição do motivo"
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Col sm="12">
                      <Button
                        variant="outline-primary"
                        type="submit"
                        className="float-right"
                        disabled={isSubmitting || !podeSalvarMotivo}
                      >
                        <FiSave />
                        <span>&nbsp;Salvar</span>
                      </Button>
                      {codigo_motivo_editando !== 0 && (
                        <Button
                          variant="outline-secondary"
                          className="float-right mr-2"
                          onClick={this.cancelarEditarMotivo}
                        >
                          <FiSave />
                          <span>&nbsp;Cancelar</span>
                        </Button>
                      )}
                    </Col>
                  </Form.Group>
                </>
              </Form>
            </Col>
            <ListGroup>
              {motivos.map(m => {
                return (
                  <ListGroup.Item key={m.codigo}>
                    <Row>
                      <Col sm={10}>
                        <p>{m.descricao}</p>
                        <small>{m.tag || '(tag não informada)'}</small>
                      </Col>
                      <Col sm={2}>
                        <Button
                          variant="link"
                          onClick={() => this.confirmarExcluirMotivo(m.codigo)}
                          className="float-right text-danger"
                        >
                          <MdDelete />
                        </Button>
                        <Button
                          variant="link"
                          className="float-right text-warning"
                          onClick={() => this.iniciarEditarMotivo(m.codigo)}
                        >
                          <MdEdit />
                        </Button>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
          </Card.Body>
        </Card>

        <Card className="m-4">
          <Card.Header>Regras Segundo Proponente</Card.Header>
          <Card.Body>
            <Formik
              enableReinitialize={true}
              initialValues={this.state.regraInicial}
              validationSchema={Yup.object().shape({
                codigo_familia: Yup.number().required(
                  'Selecione um empreendimento'
                ),
                tempo_sem_atendimento: Yup.number()
                  .min(0)
                  .required('Informe os dias'),
                utilizar_regra: Yup.boolean().required(),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  await api.atualizarParametrosSegundoProponente({
                    ...values,
                    utilizar_regra: values.utilizar_regra ? 1 : 0,
                  });
                  toast.success('Parâmetros atualizados com sucesso!');
                  const lista = await api.buscarParametrosSegundoProponente();
                  this.setState({
                    parametrosSegundoProponente: Array.isArray(lista)
                      ? lista
                      : [],
                  });
                } catch (error) {
                  toast.error(error.message || 'Erro ao atualizar parâmetros');
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldValue,
                isSubmitting,
              }) => {
                const optionsEmpreendimento = (
                  (this.props.empreendimentos &&
                    this.props.empreendimentos.sort) ||
                  []
                ).map(item => ({
                  value: parseInt(item.codigo, 10),
                  label: item.descricao,
                }));
                return (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="regra.codigo_familia">
                      <Form.Label>Empreendimento</Form.Label>
                      <Selector
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        value={
                          values.codigo_familia
                            ? optionsEmpreendimento.find(
                                o =>
                                  o.value ===
                                  parseInt(values.codigo_familia, 10)
                              )
                            : null
                        }
                        noOptionsMessage={() =>
                          'Nenhum empreendimento encontrado'
                        }
                        placeholder="Pesquisar empreendimentos..."
                        options={optionsEmpreendimento}
                        onChange={option => {
                          const codigo = option
                            ? parseInt(option.value, 10)
                            : null;
                          setFieldValue('codigo_familia', codigo);
                          const atual = (
                            this.state.parametrosSegundoProponente || []
                          ).find(p => p.codigo_familia === codigo);
                          if (atual) {
                            setFieldValue(
                              'tempo_sem_atendimento',
                              typeof atual.tempo_sem_atendimento_proponente === 'number'
                                ? atual.tempo_sem_atendimento_proponente
                                : 30
                            );
                            setFieldValue(
                              'utilizar_regra',
                              !!atual.utilizar_regra
                            );
                          } else {
                            setFieldValue('tempo_sem_atendimento', 30);
                            setFieldValue('utilizar_regra', false);
                          }
                        }}
                        isDisabled={
                          isSubmitting || optionsEmpreendimento.length === 0
                        }
                      />
                      {errors.codigo_familia && touched.codigo_familia && (
                        <small className="form-text text-danger">
                          {errors.codigo_familia}
                        </small>
                      )}
                    </Form.Group>

                    <Form.Group controlId="regra.tempo_sem_atendimento">
                      <Form.Label>Tempo sem atendimento (dias)</Form.Label>
                      <Form.Control
                        type="number"
                        name="tempo_sem_atendimento"
                        value={values.tempo_sem_atendimento}
                        onChange={e =>
                          setFieldValue(
                            'tempo_sem_atendimento',
                            parseInt(e.target.value || '0', 10)
                          )
                        }
                        disabled={isSubmitting}
                        placeholder="Ex.: 30"
                        isInvalid={
                          touched.tempo_sem_atendimento &&
                          !!errors.tempo_sem_atendimento
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.tempo_sem_atendimento}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="regra.utilizar_regra">
                      <Form.Check
                        type="checkbox"
                        label="Utilizar regra"
                        checked={values.utilizar_regra}
                        onChange={e =>
                          setFieldValue('utilizar_regra', e.target.checked)
                        }
                        disabled={isSubmitting}
                      />
                    </Form.Group>

                    <div className="d-flex justify-content-end">
                      <Button
                        variant="primary"
                        type="submit"
                        disabled={isSubmitting || !values.codigo_familia}
                      >
                        <FiSave />
                        <span>&nbsp;Salvar</span>
                      </Button>
                    </div>

                    <ListGroup className="mt-3">
                      {(this.state.parametrosSegundoProponente || []).map(p => {
                        const familia = optionsEmpreendimento.find(
                          o => o.value === parseInt(p.codigo_familia, 10)
                        );
                        return (
                          <ListGroup.Item key={p.codigo_familia}>
                            <Row>
                              <Col sm={10}>
                                <p>
                                  {familia
                                    ? familia.label
                                    : `Família ${p.codigo_familia}`}
                                </p>
                                <small>
                                  Tempo sem atendimento:{' '}
                                  {typeof p.tempo_sem_atendimento_proponente === 'number'
                                    ? p.tempo_sem_atendimento_proponente
                                    : 30}{' '}
                                  dias | Utilizar regra:{' '}
                                  {p.usar_regra_proponente ? 'Sim' : 'Não'}
                                </small>
                              </Col>
                              <Col sm={2}>
                                <Button
                                  variant="link"
                                  className="float-right text-warning"
                                  onClick={() =>
                                    this.iniciarEditarParametro(
                                      p.codigo_familia
                                    )
                                  }
                                >
                                  <MdEdit />
                                </Button>
                              </Col>
                            </Row>
                          </ListGroup.Item>
                        );
                      })}
                    </ListGroup>
                  </Form>
                );
              }}
            </Formik>
          </Card.Body>
        </Card>

        {/* TODO: fazer disso um componente */}
        <Modal
          show={confirmarExcluirMotivo}
          onHide={this.cancelarExcluirMotivo}
        >
          <Modal.Header closeButton>
            <Modal.Title>Desativando Motivo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Deseja desativar o motivo de descarte '
            {motivoDesativando == null ? '' : motivoDesativando.descricao}'?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.cancelarExcluirMotivo}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.excluirMotivo}>
              Desativar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => ({ empreendimentos: state.empreendimentos });
export default connect(mapStateToProps)(ConfiguracoesFluxoProspecto);
